import { accountDetailDataSelectorConfig } from './accountDetailData'

export const selectorsConfig = {
  ...accountDetailDataSelectorConfig,
}
